import CssVariables from '../../assets/styles/css-variables';
import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    root: {
        overflowY: 'unset',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },
    header: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 60,
        background: '#FEBF33',
        color: CssVariables.white,
        '& .alert-icon': {
            marginLeft: 20,
            marginRight: 10,
        },
        '& .alert-text': {
            fontWeight: 'bold',
        },
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        flex: 1,
        padding: '25px 30px 0 30px',
        textAlign: 'center',
        '& h5': {
            fontWeight: 900,
            fontSize: 17,
        },
        '& .description': {
            marginTop: 5,
            marginBottom: 25,
            fontSize: 14,
            lineHeight: '19px',
        },
        '& .description1': {
            fontSize: 14,
            marginBottom: 25,
        }
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0px 15px 15px 15px',
    }
}));
//# sourceMappingURL=styles.js.map